import { t, getWeekDay, getDayAndMonth, getFullMinute } from "../../services/formatters";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useFilialiPage } from "./useFilialiPage";
import widgetOptions from "../../config/widgets.json";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import pinIcon from "../../assets/imgs/recap-pin-icon.svg";
import "@splidejs/splide/dist/css/splide.min.css";
import { useComponentMetric } from "../../lib/otel";
import "./FilialiPage.css";

export const FilialiPage = () => {
    const {
        next,
        read,
        update,
        subSlider,
        daySlider,
        onFilialiSlideChange,
        onGiorniSlideChange,
        isFilialiSlideBusy,
        isCfPageReady,
        showMap,
        currentMapToShow,
        fetchErrorMessage,
        fetchError,
        setFetchError,
    } = useFilialiPage();

    useComponentMetric("filiali", { fetchError, fetchErrorMessage, fallbackErrorMessage: "errore recupero filiali" });

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa-mps/fissa-appuntamento/data-appuntamento",
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="filiali-page">
            {!read("id_filiale_direct") && <Breadcrumb text={read("luogo")} navigateTo="/" />}

            <div className={`section page-title-component center-on-tablet`}>
                <h1>
                    <span>Ciao!</span> <br /> <span>Il tuo appuntamento:</span>
                </h1>
            </div>

            {/* SLIDERS */}
            {/* filiali */}
            <div id="subs-splide" className={`section full-screen on-mobile`}>
                <div className="fade"></div>
                <Splide
                    ref={subSlider}
                    options={{ ...widgetOptions.splideFiliali, start: read("filialeSceltaIdx") || 0, drag: read("filiali").length > 1 }}
                    onMoved={(splide, newIdx) => {
                        onFilialiSlideChange(newIdx);
                        update("filialeSceltaIdx", newIdx);
                    }}
                    onClick={(splide, slide) => {}}
                    onReady={(splide, slide) => {}}>
                    {read("filiali").map((i, idx) => (
                        <SplideSlide key={`${i.filiale}-${idx}`}>
                            <div className={`white-box subsidiary-card-component clickable  ${currentMapToShow == `map-${idx}` ? "show-map" : ""}`}>
                                <h2>{i.nomeFiliale}</h2>
                                <p aria-label={i.indirizzo} className={`subsidiary-card-subtitle ellipsis--2  ${!i.indirizzo ? "invisible" : ""}`}>
                                    {i.indirizzo || "&nbsp;"}
                                    <br />
                                    {i.provincia} - {i.cap} {i.citta}
                                </p>
                                <div aria-label={i.indirizzo} className={`subsidiary-card-details ${!i.indirizzo ? "invisible" : ""}`}>
                                    Orario apertura al pubblico
                                    <table border={0} cellSpacing={0}>
                                        <tbody>
                                            <tr>
                                                <td>MATTINA</td>
                                                <td>{i.orarioMattina}</td>
                                            </tr>
                                            <tr>
                                                <td>POMERIGGIO</td>
                                                <td>{i.orarioPomeriggio}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className={`subsidiary-card-show-map text-sm ${currentMapToShow == `map-${idx}` ? "anim-pulse anim-slow" : ""}`}>
                                    <span
                                        onClick={() => {
                                            showMap(`map-${idx}`, i.coordinate);
                                        }}>
                                        <img src={pinIcon} /> &nbsp; {currentMapToShow == `map-${idx}` ? t("nascondi_mappa") : t("mostra_mappa")}
                                    </span>
                                </div>

                                <div className="map-container">
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                        }}
                                        id={`map-${idx}`}></div>
                                </div>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* giorni */}
            <div id="days-splide" className="section full-screen on-mobile">
                <div className="fade"></div>
                <Splide
                    ref={daySlider}
                    options={{ ...widgetOptions.splideGiorni, start: read("dayIdx") || 0 }}
                    onMove={() => {}}
                    onDragging={() => {}}
                    onMoved={(splide, newIdx) => {
                        onGiorniSlideChange(newIdx);
                    }}
                    onReady={() => {}}>
                    {read("disponibilita").map((i, idx) => (
                        <SplideSlide key={`${i.data}-${idx}`}>
                            <div className={`white-box day-card-component text-uppercase clickable ${idx == 99 ? "show-next-days" : ""}`}>
                                <h2 className="actual-date">
                                    {getWeekDay(i.data, true)}
                                    {getWeekDay(i.data, true) && <br />}
                                    <span dangerouslySetInnerHTML={{ __html: getDayAndMonth(i.data, true) || "" }}></span>
                                </h2>

                                <h2 className="fake-date">Mostra successive</h2>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* ore */}
            <div className={`hour-grid-component ${isFilialiSlideBusy() ? "is-loading" : ""}`}>
                {isFilialiSlideBusy() && (
                    <>
                        <div className="sliders-loader loading-placeholder hours-loader"></div>
                    </>
                )}
                <div className="flex-row hours-grid__cells-container">
                    {(read("orari") || []).map((i, idx) => (
                        <div
                            key={`hour-grid-${idx}`}
                            onClick={() => {
                                if (!i.disponibile) return;
                                update("orarioScelto", { idx });
                                update("orarioSceltoId", i.id);
                                update("orarioSceltoLabel", i.label);
                            }}
                            className={`white-box day-card-component hour-card-component text-uppercase clickable flex-cell hour-cell ${
                                read("orarioScelto") && idx == read("orarioScelto").idx && i.disponibile == true ? "is-active" : ""
                            } ${!i.disponibile ? "disabled" : ""}`}>
                            <h2>{i.label}</h2>
                        </div>
                    ))}
                </div>
            </div>

            <br />

            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isCfPageReady()} onClick={next} classList="btn-responsive always-style" loading={false} text={t("avanti")} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>
        </div>
    );
};
